<template>
    <div class="modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ isNewDatalogger ? 'Crear datalogger' : 'Editar datalogger' }}</h5>
                    <button type="button" @click="closeModal" style="background: none; border: none; font-size: 1.5rem; line-height: 1;">&times;</button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="handleSubmit">
                        <div class="form-group">
                            <label for="name-input">Nombre:</label>
                            <input v-model="selectedDatalogger.name" id="name-input" class="form-control" required />
                        </div>
                        <div class="form-group mt-2">
                            <label for="type-input">Tipo:</label>
                            <input v-model="selectedDatalogger.type" id="type-input" class="form-control" required />
                        </div>
                        <div class="form-group mt-2">
                            <label for="host-input">Host:</label>
                            <input v-model="selectedDatalogger.host" id="host-input" class="form-control" required />
                        </div>
                        <div class="form-group mt-2">
                            <label for="port-input">Puerto:</label>
                            <input v-model="selectedDatalogger.port" id="port-input" type="number" class="form-control" required />
                        </div>
                        <div class="form-group mt-2 d-flex align-items-center">
                            <label for="use_tls-input" class="me-2">Usa TLS:</label>
                            <div class="form-check form-switch mb-0">
                                <input v-model="selectedDatalogger.use_tls" class="form-check-input" type="checkbox" id="use_tls-input" />
                                <label class="form-check-label" for="use_tls-input"></label>
                            </div>
                        </div>
                        <div class="form-group mt-2">
                            <label for="username-input">Nombre de usuario:</label>
                            <input v-model="selectedDatalogger.username" id="username-input" class="form-control" required />
                        </div>
                        <div class="form-group mt-2">
                            <label for="password-input">Contraseña:</label>
                            <input v-model="selectedDatalogger.password" id="password-input" type="password" class="form-control" required />
                        </div>
                        <div class="form-group mt-2">
                            <label for="client-id-input">Nombre de cliente:</label>
                            <input v-model="selectedDatalogger.client_id" id="client-id-input" class="form-control" required />
                        </div>
                        <hr>
                        <div class="d-flex justify-content-end">
                            <button type="button" class="btn btn-danger me-2" @click="closeModal">Cancelar</button>
                            <button type="submit" class="btn btn-success">Guardar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';

export default {
    name: 'DataloggerModal',
    props: {
        selectedDatalogger: {
            type: Object,
            required: true
        },
        isNewDatalogger: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        handleSubmit() {
            this.isNewDatalogger ? this.createDatalogger() : this.updateDatalogger();
        },
        createDatalogger() {
            axios.post('/api/datalogger', this.selectedDatalogger)
                .then(response => {
                    showCustomSuccessSweetAlert('Datalogger creado correctamente');
                    this.$emit('form-submitted');
                    this.closeModal();
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        updateDatalogger() {
            axios.patch(`/api/admon/datalogger/${this.selectedDatalogger.id}`, this.selectedDatalogger)
                .then(response => {
                    showCustomSuccessSweetAlert('Datalogger actualizado correctamente');
                    this.$emit('form-submitted');
                    this.closeModal();
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        closeModal() {
            this.$emit('close-modal');
        }
    }
};
</script>